import { render } from "./CardFoto.vue?vue&type=template&id=7d38d7bb&scoped=true"
import script from "./CardFoto.vue?vue&type=script&lang=js"
export * from "./CardFoto.vue?vue&type=script&lang=js"

import "./CardFoto.vue?vue&type=style&index=0&id=7d38d7bb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d38d7bb"]])

export default __exports__